import {
    useCommonActsKC2GroupManager,
    useCommonActsKc2GroupManagerData,
} from 'pages/Project/Common/ActsKC2ListContainer/hooks';

import { useCallback } from 'react';

import { bimIsUniqueActKC2GroupNameGql, bimWorkOrderActsKC2SelectionListGql } from '../BimWorkOrderActsKc2ListQueries';

import { useBimActsKc2GroupManagerColumns } from './useBimActsKc2GroupManagerColumns';
import { useBimActsKc2GroupSaver } from './useBimActsKc2GroupSaver';

export const useBimActsKc2GroupManager = ({
    workOrderId,
    actKC2GroupId,
    refreshActListData,
    handlerCloseEditGroup,
}: {
    workOrderId: number;
    actKC2GroupId: number | null;
    refreshActListData: () => void;
    handlerCloseEditGroup: () => void;
}) => {
    const { groupManagerData, defaultData, isLoading, handleToggleModalState, groupManagerOpened } =
        useCommonActsKc2GroupManagerData({
            actKC2GroupId,
            workOrderId,
            getDataQuery: bimWorkOrderActsKC2SelectionListGql,
            handlerCloseEditGroup,
        });

    const { control, handleSubmit, isDirty, allUnchecked, isNotUniqueActKC2GroupName } = useCommonActsKC2GroupManager({
        actKC2GroupId,
        defaultData,
        groupManagerOpened,
        workOrderId,
        uniqueGroupNameQuery: bimIsUniqueActKC2GroupNameGql,
    });

    const groupManagerColumns = useBimActsKc2GroupManagerColumns({ control });

    const onSuccess = useCallback(() => {
        refreshActListData();
        handleToggleModalState();
    }, [handleToggleModalState, refreshActListData]);

    const { isCommit, handleSaveGroup } = useBimActsKc2GroupSaver({ workOrderId, onSuccess, actKC2GroupId });

    return {
        control,
        groupManagerColumns,
        groupManagerData: groupManagerData?.bimWorkOrderActsKC2SelectionList?.items ?? [],
        groupManagerOpened,
        handleToggleModalState,
        isLoading,
        handleSaveGroup: handleSubmit(handleSaveGroup),
        isCommit,
        isConfirmDisabled: allUnchecked || isNotUniqueActKC2GroupName,
        isFormDirty: isDirty,
    };
};
